'use strict';

angular.module('ClinicApp').directive('appointmentRequestTimeSelector', function() {
  return {
    templateUrl: '/views/directives/_appointment-request-time-selector.html',
    link: function($scope) {
      $scope.isShowSuggestAnotherTime = false;

      $scope.$watch('userSelected.respond.dateTime', function() {
        if (!$scope.userSelected.respond.dateTime) {
          return;
        }
        $scope.userSelected.respond.action = {
          name: 'reschedule',
          dateTime: $scope.userSelected.respond.dateTime,
        };
      });

      $scope.suggestAnotherTimeClass = function() {
        if ($scope.isAction('reschedule')) {
          if ($scope.respondForm.$valid) {
            if (_.get($scope, 'respondForm.customTime.$warning.outsideProviderHours')) {
              return 'bg-warning';
            }
            return 'bg-success';
          } else {
            if ($scope.respondForm._submitted) {
              return 'bg-danger';
            }
          }
        }
        return 'bg-none';
      };

      $scope.selectBlock = function(index) {
        $scope.isShowSuggestAnotherTime = false;
        $scope.userSelected.respond.action = {
          name: 'schedule',
          block: index,
        };
      };

      $scope.showSuggestAnotherTime = function() {
        $scope.isShowSuggestAnotherTime = true;
        $scope.userSelected.respond.action = {
          name: 'reschedule',
        };
      };

      $scope.isAction = function(name) {
        return _.get($scope, 'userSelected.respond.action.name') == name;
      };
    },
  };
});
